import React, { useContext } from 'react'
import ReactDOM from 'react-dom'

import DataContext from '../../contexts/data.jsx'

const Persons = ({ setData }) => {
    const data = useContext(DataContext),
    handleChangePerson = (e) => {
        const newContextData = Object.assign({}, data)

        newContextData.contacts.person = parseInt(e.target.value)

        setData(newContextData)
    }

    return <div className="happy-order__persons">
        { data.data.persons.map((person) => {
            return <div className="happy-order__persons-item" key={ `contacts-person-${ person.ID }` }>
                <div className="radio" key={ `contacts-person-${ person.ID }` }>
                    <input
                        type="radio"
                        onChange={ handleChangePerson }
                        name="happy-order__person"
                        id={ `happy-order__person-${ person.ID }` }
                        defaultChecked={ (data.contacts.person === person.ID) }
                        value={ person.ID }
                    />
                    <label htmlFor={ `happy-order__person-${ person.ID }` }>
                        { person.NAME }
                    </label>
                </div>
            </div>
        }) }
    </div>
}

export default Persons